import { html } from '@shared/utils/rendering/html';

import Chip from '@shared/components/chips';
import BooleanRadio from '@shared/components/forms/form-components/checkboxes/boolean-radio';

import { Ratings, RatingsFromId } from '../../../constants/chips/ratings.constants';

import FileDownload from '../../../components/shared/form-fields/file-download';
import { ratingFieldOverride } from './subcomponent-form.config';

export const ReviewEvidenceFormLayout = {
    uploadEvidence: { column: 'col-12', formGroup: '', css: '' },
    rating: { column: 'col-4', formGroup: '', css: '', disabled: true },
    haveReviewed: { column: 'col-8', formGroup: '', css: '' },
    rationale: { column: 'col-12', formGroup: '', css: '', disabled: true },
    canAccept: { column: 'col-12', formGroup: '', css: '' },
    comment: { column: 'col-12', formGroup: '', css: '' },
};

const convertOptionToChip = (option) => {
    const item = RatingsFromId(option.value);

    return item
        ? html`<${Chip} label=${item.label} type="indicator-chip" css=${item.css} />`
        : option.text;
};

export const ReviewEvidenceFormOptions = {
    options: {
        rating: Object.values(Ratings).map((item) => {
            return {
                value: item.value,
                text: item.text,
            };
        }),
    },
    layout: ReviewEvidenceFormLayout,
    includeSaveButton: false,
    converters: {
        rating: convertOptionToChip,
    },
    overrides: {
        uploadEvidence: (inputProps, layoutSettings, options, fieldDesc, fieldRef) => {
            const render = html`<${FileDownload}
                ref=${fieldRef}
                inputProps=${inputProps}
                layoutSettings=${layoutSettings}
            />`;
            return { render, fieldRef };
        },
        canAccept: (inputProps, layoutSettings, options, fieldDesc, fieldRef) => {
            const render = html`<${BooleanRadio}
                ref=${fieldRef}
                inputProps=${inputProps}
                layoutSettings=${layoutSettings}
                options=${options}
            />`;
            return { render, fieldRef };
        },
        // Without this override, the venus default array-field renderer only wires
        // settings.transformer, never selectedTransformer. Because `rating` is always
        // array-wrapped ([ratingObject]) even for this single-select field,
        // useDropdownSelection's isMultiple check (settings.multiple || Array.isArray(value))
        // takes the multi-select branch, and without selectedTransformer that branch ignores
        // the transformer entirely and falls back to a generic removable filter-chip showing
        // raw text - not the coloured indicator-chip the rating should show.
        rating: ratingFieldOverride,
    },
};
